// extracted by mini-css-extract-plugin
module.exports = {"body":"MergeItineraryModal_body__NoIxr","modalContent":"MergeItineraryModal_modalContent__26a9h","dateSubtitle":"MergeItineraryModal_dateSubtitle__2Yq6P"};